/* eslint no-useless-concat: 0 */
/* eslint no-useless-concat: 0 */
/* eslint no-unused-vars: 0 */

import React, { Component } from "react";
import { withRouter, Redirect } from 'react-router-dom'
import PageTitle from "../../Theme/PageTitle";
import DashboardLayout from "../../Theme/DashboardLayout";
import { Modal, Switch, message, Tabs, Select, Mentions, Dropdown, Button, Menu } from "antd";
import GanttChartTimeline, {
  TimelineHeaders,
  SidebarHeader,
  TimelineMarkers,
} from 'react-calendar-timeline/lib'
import containerResizeDetector from 'react-calendar-timeline/lib/resize-detector/container';
import './ScheduleView.scss';
import moment from 'moment-timezone';
import _ from 'lodash';
import groupRendererLive from '../utils/live-schedules/groupRendererLive';
import generateGroups from './utils/generate-timeline/generateGroups';
import generateItems from './utils/generate-timeline/generateItems';
import Spinner from '../../Theme/Spinner';
import CustomPrimaryDateHeader from './CustomPrimaryDateHeader';
import CustomDateHeader from './CustomDateHeader';
import CustomHourlyHeader from './CustomHourlyHeader';
import DayMarkers from './DayMarkers';
import ItemModalDetails from './ItemModalDetails';
import ApprovalFindButton from '../../Approval/ApprovalFindButton';
import { bindActionCreators } from "redux";
import * as liveScheduleActions from '../../../redux/actions/liveScheduleActions';
import * as postedScheduleActions from '../../../redux/actions/postedScheduleActions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LiveSchedulesToggle from "../LiveSchedulesToggle";
import WorkerMultiSelect from '../WorkerMultiSelect';
import AuthLogic from '../../../AuthLogic';
import generateItemDetails from './utils/generateItemDetails';
import contextMenuArrays from '../utils/live-schedules/context-menu-arrays';
import LiveScheduleUpdate from '../LiveScheduleUpdate/LiveScheduleUpdate';
import removeObjectIds from '../utils/removeObjectIds';
import liveScheduleActionsMenu from '../utils/live-schedules/drop-down-tables/liveScheduleActionsMenu';
import { Understood } from '../../Notification';

const { TabPane } = Tabs;
const { Option } = Select;

/**
 * Displays the one to two day schedule. When the component is first called it uses redux to call the api to get the
 * data from the database. It then calls generateItems and generateResources to correctly format the data it recieves from the api.
 * After the data has beeen formatted correctly it displays the information.
 */

class LiveScheduleView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: '',
      liveSchedule: '',
      resources: '',
      filteredResources: [],
      items: '',
      optimisticItems: generateItems(this.props.optimisticLiveSchedule),
      optimisticLiveSchedule: this.props.optimisticLiveSchedule,
      optimisticReRender: this.props.optimisticReRender,
      resourceCollectionName: '',
      resourceCollectionId: '',
      startDate: '',
      scheduleFormat: '',
      itemModal: false,
      itemDetails: '',
      tourModalDisplay: '',
      toggleChange: false,
      backRedirect: '',
      selectedItem: {},
      liveScheduleUpdate: false,
      disableButton: false,
      openActionModal: false,
      actionType: '',
    };
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
    this.customBrowserBackNavigation();
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.history.location;
      if (pathname === '/live-schedule-view-short') {
        this.setState({
          backRedirect: '/schedules'
        });
      }
    }
  }

  readyApiCall = async () => {
    const userId = this.props.user.login.id;
    const resourceId = this.props.user.login.resourceId || 0;
    if (this.props.location.state) {
      const { startDate, scheduleFormat, resourceCollectionName, resourceCollectionId } = this.props.location.state;
      let formattedStartDate = startDate;
      if(moment.isMoment(startDate)){
        formattedStartDate = startDate.format('MM/DD/YYYY');
      } 
      await this.props.actions.updateLiveScheduleParameters({ startDate: formattedStartDate, scheduleFormat, resourceCollectionName, resourceCollectionId });
      this.getDataFromApi(formattedStartDate, scheduleFormat, resourceCollectionId, userId, resourceId, resourceCollectionName);
    } else {
      const { startDate, scheduleFormat, resourceCollectionName, resourceCollectionId } = this.props.liveScheduleParameters;
      let formattedStartDate = startDate;
      if(moment.isMoment(startDate)){
        formattedStartDate = startDate.format('MM/DD/YYYY');
      }
      this.getDataFromApi(formattedStartDate, scheduleFormat, resourceCollectionId, userId, resourceId, resourceCollectionName);
    }
  }

  getDataFromApi = async (startDate, scheduleFormat, resourceCollectionId, userId, resourceId, resourceCollectionName) => {
    //for api to work start date must start at the beginning of the day
    let startDateFixFormat ="";
    if(startDate.length==10) {
       startDateFixFormat= startDate.substring(6,10)+'-'+startDate.substring(0,2)+'-'+startDate.substring(3,5);
    } else {
      startDateFixFormat = startDate.year()+'-'+(startDate.month()+1).toString().padStart(2,0)+'-'+startDate.day().toString().padStart(2,0);
    }
    let momentStartDate = moment(startDateFixFormat).tz('America/New_York').startOf('day');

    const { scheduleView } = this.props.user.securityLevels;
    
    await this.props.actions.fetchLiveSchedules(momentStartDate, scheduleFormat, resourceCollectionId, userId, resourceId, scheduleView)
      .catch(error => {
        console.log(error);
        alert("Loading Live Schedules failed\n" + JSON.stringify(error));
      });
      
    this.setState({
      resourceCollectionName,
      resourceCollectionId,
      liveSchedule: await this.props.liveSchedule
    }, () => {
      const items = generateItems(this.state.liveSchedule.liveSchedule, scheduleFormat, startDate).map(item => {
        item.end_time = item.end_time.utc()
        item.start_time = item.start_time.utc()
        return item
      })
      console.log('liveScheduleView',items)
      this.setState({
        startDate,
        scheduleFormat,
        // items: items,
        items: generateItems(this.state.liveSchedule.liveSchedule, scheduleFormat, startDate),
        resources: generateGroups(this.state.liveSchedule.liveSchedule)
      }, () => {
        // refresh optimistic data w/ real data
        this.props.actions.updateOptimisticReRenderStatus(false);
        this.props.actions.updateOptimisticSchedule(this.state.liveSchedule.liveSchedule);
        this.setState({
          optimisticItems: this.state.items,
          optimisticLiveSchedule: this.state.liveSchedule.liveSchedule
        });
      });
      
    });
  }

  handleEditModeToggle = async () => {
    let { editMode } = this.props;
    await this.props.actions.updateEditModeStatus(!editMode);
    message.config({
      top: 60,
    });
    editMode = await this.props.editMode;
    message.success(`Edit mode ${editMode ? 'enabled' : 'disabled'}`);
  };

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  handleItemClick = async (item) => {
    this.setState({
      selectedItem: item,
      optimisticReRender: await this.props.optimisticReRender
    }, async () => {
      let itemDetails = await generateItemDetails(item, this.state);
      this.setState({
        itemModal: true,
        itemDetails
      });
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      itemModal: false,
    });
  }

  handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => { 

    let minTime = moment(this.state.startDate).startOf('day');

    let maxTime
    if (this.state.scheduleFormat === 1) {
      maxTime = moment(this.state.startDate).endOf('day');
    }
    else {
      maxTime = moment(this.state.startDate).add(1, 'days').endOf('day');
    }
    if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
      updateScrollCanvas(minTime, maxTime)
    } else if (visibleTimeStart < minTime) {
      updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
    } else if (visibleTimeEnd > maxTime) {
      updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
    } else {
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
    }

  }
  // toggle between 1, 2, 7 & 9 day format views
  handleToggleChange = (redirectInfo) => {
    this.setState({
      scheduleFormat: redirectInfo.scheduleFormat
    }, () => {
      if (redirectInfo.redirect) {
        this.readyApiCall();
      } else {
        this.refreshPage();
      }
    });
  }

  refreshPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  setFilteredResourceArray = (filteredArray) => {
    this.setState({
      filteredResources: []
    }, () => this.setState({ filteredResources: filteredArray }));
  }

  handleItemContextSelect = (key) => {
    // mount LiveScheduleUpdate to handle CRUD operations
    if (this.state.selectedItem.itemType) {
      this.setState({
        liveScheduleUpdate: true,
        contextMenuSelection: key.item.props.children, // dropdown selection text
      }, () => {
        this.handleModalCancel();
      });
    }
  }

  // dropdown lists that appear in context menus for items
  selectContextMenuArray = (item) => {
    let menuArray = [];
    if (item && item.itemType === 'tour' && !(item.id.includes('optimistic'))) {  // don't edit optimistic items
      menuArray = contextMenuArrays.tour;
    }
    if (item && item.itemType === 'off-time' && !(item.id.includes('optimistic'))) {
      menuArray = contextMenuArrays.offTime;
      if (!item.dayRequestId) {
        menuArray = menuArray.filter(menu => menu.name !== 'Edit Days Off Request');
      }
    }
    if (item && item.itemType === 'assignment' && !(item.id.toString().includes('optimistic'))) {
      menuArray = contextMenuArrays.assignment;
    }
    if (item && item.itemType === 'off-request' && !(item.id.toString().includes('optimistic'))) {
      menuArray = contextMenuArrays.daysOffRequest;
    }
    return menuArray;
  }

  updateSelectedItem = (item) => {
    this.setState({
      selectedItem: item
    });
  }

  closeLiveScheduleUpdate = (liveScheduleUpdateState) => {

    if (liveScheduleUpdateState) {
      if (
        !liveScheduleUpdateState.crudError
        && !liveScheduleUpdateState.crudLoading
        && !liveScheduleUpdateState.deleteJobElementLoading
        && !liveScheduleUpdateState.deleteEmptyJobLoading
        ) {
          this.setState({
            liveScheduleUpdate: false
          });
      }
    }
  }

  groupRendererLive = ({group}) => {
    const props = {
      startDate: this.state.startDate,
      updateOptimisticLiveSchedule: this.updateOptimisticLiveSchedule,

    };
    return groupRendererLive(group, props);
  };

  updateOptimisticLiveSchedule = (newLiveSchedule) => {
    const newItems = generateItems(newLiveSchedule);
    this.setState({
      optimisticLiveSchedule: newLiveSchedule,
      optimisticItems: newItems
    });
  };

  handlePostSchedule = async () => {
    this.setState({ disableButton: true });
    const userId = this.props.user.login.id;
    const { resourceCollectionId } = this.props.liveScheduleParameters;
    const clonedLiveSchedule = _.cloneDeep(this.state.liveSchedule.liveSchedule);
    const clonedStartDate = _.cloneDeep(this.state.startDate);
    const clonedFilteredResources = _.cloneDeep(this.state.filteredResources);

    let filteredLiveSchedule = _.cloneDeep(clonedLiveSchedule);

    filteredLiveSchedule = filteredLiveSchedule.filter(el => { // filter out facility schedules
      return el.class !== 'Facility';
    });

    const parameters = {
      resourcesCollectionId: resourceCollectionId,  //Add S back to resources
      startDate: moment(clonedStartDate).format('M/D/YYYY'),
      format: this.state.scheduleFormat,
      userId,
      liveScheduleInput: { liveSchedule: removeObjectIds(filteredLiveSchedule) },
      allResourcesList: this.state.resourceCollectionName
    };
    

    message.config({
      top: 60,
      duration: 5
    });
    await this.props.actions.createPostedSchedule(parameters)
      .then(async () => {
        let response = await this.props.postedScheduleResult;
        if (response.status === true) {
          message.success(response.message);
        } else {
          message.error(response.message.toString());
        }
        this.setState({ disableButton: false });
      })
      .catch(error => {
        alert(error);
      });
  }
  handleButtonClick = (e) => {

    if (!this.checkIfCanPost()) {
      let message = this.state.scheduleFormat === 1 ? 'Daily posting can only be done 8 days from today\'s date' : 'In 2 days schedule, you can post today and tomorrow only';
      Understood('key', { title: 'Can\'t Post Schedule', content: message }, () => { });
      return;
    }

    this.setState({
      openActionModal: true,
      actionType: liveScheduleActionsMenu[e.key],
      keyValue: e.key,
      actionModalText: 'Are you sure you want to ' + liveScheduleActionsMenu[e.key].toLowerCase() + '?'
    });
  }

  checkIfCanPost = () => {
    let currentDay = moment();
    if (this.state.scheduleFormat === 1) {
      if (moment.isMoment(this.state.startDate)) {
        let dayDiff = this.state.startDate.diff(currentDay, 'days');
        return dayDiff >= 7 ? false : true;
      } else {
        moment(this.state.startDate)
        let dayDiff = moment(this.state.startDate).diff(currentDay, 'days');
        return dayDiff >= 7 ? false : true;
      }
    } else {
      if (moment.isMoment(this.state.startDate)) {
        let dayDiff = this.state.startDate.diff(currentDay, 'days');
        return dayDiff >= 1 ? false : true;
      } else {
        moment(this.state.startDate)
        let dayDiff = moment(this.state.startDate).diff(currentDay, 'days');
        return dayDiff >= 1 ? false : true;
      }
    }
  }

  handleCorrectAction = () => {
    switch (this.state.keyValue) {
      case '0':
        this.handlePostSchedule();
        this.setState({ openActionModal: false });
        break;
      default:
        alert('No action was found');
        this.setState({ openActionModal: false });
    }
  }

  handleCloseActionModal = () => {
    this.setState({ openActionModal: false });
  }

  render() {
    let startDateFixFormat = '';
    if (this.state.startDate.length==10){
      startDateFixFormat = this.state.startDate.substring(6,10)+'-'+this.state.startDate.substring(0,2)+'-'+this.state.startDate.substring(3,5);
    }else if (this.state.startDate.length>0) {
      startDateFixFormat = this.state.startDate.year()+'-'+(this.state.startDate.month()+1)+'-'+this.state.startDate.day().toString().padStart(2,0);
    }
    const { selectedItem } = this.state;
    const { optimisticReRender } = this.props;
    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/schedules');
      return <Redirect to={this.state.backRedirect} />
    }
    if (this.state.resources && this.state.items && window.innerWidth && (!optimisticReRender || (optimisticReRender && this.state.optimisticItems))) {
      return (
        <DashboardLayout>
          <PageTitle title={'Live Schedule'} subTitle={this.state.resourceCollectionName} />
          <div style={{ display: 'flex' }}>
            <LiveSchedulesToggle scheduleFormat={this.state.scheduleFormat} onToggleChange={this.handleToggleChange} />
            {AuthLogic.editMode(this.props.user) &&
              (
                <div style={{ marginLeft: 15 }}>
                  {/* Edit Mode <Switch checked={this.props.editMode} onChange={this.handleEditModeToggle} /> */}
                </div>
              )
            }
          </div>
          {
            this.props.editMode ?
              <div>
                {AuthLogic.approvals(this.props.user) && (
                  <ApprovalFindButton resourceCollection={{
                    resourceCollectionName: this.state.resourceCollectionName,
                    resourceCollectionId: this.state.resourceCollectionId
                  }} />
                )}
                <div style={{ paddingBottom: 20 }}>
                  <Dropdown trigger={['click']}  overlay={
                    <Menu onClick={this.handleButtonClick}>
                      {
                        liveScheduleActionsMenu.map((action, index) => (
                          <Menu.Item key={index}>{action}</Menu.Item>
                        ))
                      }
                    </Menu>
                  }>
                    <Button id='select-action' disabled={this.state.disableButton}>Select Action</Button>
                  </Dropdown>
                </div>
                <WorkerMultiSelect
                  workers={this.state.resources}
                  returnFilteredArray={this.setFilteredResourceArray}
                />
              </div>

              : null
          }
          {moment.tz.setDefault('UTC')}
          <GanttChartTimeline
            groups={this.state.filteredResources.length === 0 ? this.state.resources : this.state.filteredResources}
            items={!optimisticReRender ? this.state.items : this.state.optimisticItems}
            defaultTimeStart={moment(startDateFixFormat).startOf('day')} // must use moment()
            defaultTimeEnd={this.state.scheduleFormat === 2 ?
              moment(startDateFixFormat).startOf('day').add(1, 'days').add(2, 'hours')
              :
              moment(startDateFixFormat).startOf('day').add(1, 'days')
            }
            onTimeChange={this.handleTimeChange}
            minZoom={this.state.scheduleFormat === 2 ? (60 * 60 * 26 * 1000) : (60 * 60 * 24 * 1000)}
            maxZoom={this.state.scheduleFormat === 2 ? (60 * 60 * 26 * 1000) : (60 * 60 * 24 * 1000)}
            groupRenderer={this.groupRendererLive}
            sidebarWidth={120}  // defaults to 150
            resizeDetector={containerResizeDetector} // prevents blank rightSideBar
            itemRenderer={({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
              const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
              const backgroundColor = itemContext.selected ? (itemContext.dragging ? "red" : item.selectedBgColor) : item.backgroundColor;
              const borderColor = itemContext.resizing ? "red" : item.borderColor;
              const resourceName = itemContext.dimensions.order.group.title;

              if (!itemContext.selected) {
                this.updateSelectedItem({});
              }

              return (
                <React.Fragment>
                  <div
                    {...getItemProps({
                      style: {
                        backgroundColor: backgroundColor || "undefined",
                        color: item.color || "white",
                        borderColor: itemContext.selected ? "black" : borderColor || "",
                        borderStyle: item.borderStyle || "",
                        borderWidth: itemContext.selected ? 1 : 2,
                        borderRadius: 2,
                        borderLeftWidth: itemContext.selected ? 3 : 1,
                        borderRightWidth: itemContext.selected ? 3 : 1,
                      },
                      onMouseUp: async () => {
                        item.resourceName = resourceName;
                        this.handleItemClick(item)
                      },
                      onTouchEnd: () => { // Used to select item in chrome mobile.
                        item.resourceName = resourceName;
                        this.handleItemClick(item);
                      }
                    })}
                  >
                    {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

                    <div
                      style={{
                        height: itemContext.dimensions.height,
                        overflow: "hidden",
                        paddingLeft: 3,
                        textOverflow: "string",
                        fontSize: 10,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {itemContext.title}
                    </div>

                    {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                  </div>

                  {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                </React.Fragment>
              );
            }}
            stackItems={true}
            itemHeightRatio={1}
            canChangeGroup={false}
            canMove={this.props.editMode}
            canResize={this.props.editMode}
            fixedHeader={false}
          >
            <TimelineHeaders
              style={{
                position: "sticky",
                top: 0,
                zIndex: 100
              }}
            >
              <SidebarHeader>
                {({ getRootProps }) => {
                  return <div {...getRootProps()}>
                    {/* width must match sidebarWidth */}
                    <h6 style={{ width: 120 }} className="rct-dateHeader-primary">Resource</h6></div>
                }}
              </SidebarHeader>

              < CustomPrimaryDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />
              < CustomDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

              {this.state.widescreen &&
                (
                  <CustomHourlyHeader />
                )
              }

            </TimelineHeaders>
            <TimelineMarkers>
              <DayMarkers startDate={this.state.startDate} />
            </TimelineMarkers>
          </GanttChartTimeline>
          <Modal
            zIndex={2000}
            title={this.state.itemDetails.title}
            visible={this.state.itemModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[
            ]}
          >
            <div>
              {
                    <ItemModalDetails
                      itemDetails={this.state.itemDetails}
                      scheduleType={'liveSchedule'}
                      securityLevels={this.props.user.securityLevels}
                    />
              }

              {
                this.props.editMode &&
                this.state.itemDetails.resourceClass !== 'Facility' &&
                !this.state.itemDetails.isApproved &&
                <Select
                  value={selectedItem.id && selectedItem.id.toString().includes('optimistic') ? <Mentions style={{ border: 'none', fontWeight: 'bold' }} readOnly placeholder={'Refresh page to Edit'} /> : <Mentions style={{ border: 'none', fontWeight: 'bold' }} readOnly placeholder={'Edit'} />}
                  style={{ marginTop: 10, width: 200 }}
                  dropdownStyle={{ zIndex: 2000 }}
                >
                  {
                    this.selectContextMenuArray(selectedItem).map((elem, i) => {
                      return (
                        elem.authRule &&
                        AuthLogic[`${elem.authRule}`] &&
                        AuthLogic[`${elem.authRule}`](this.props.user) &&
                        <Option
                          key={elem.name}
                          value={elem.name}
                          onClick={(key) => this.handleItemContextSelect(key)}
                        >
                          {elem.name}
                        </Option>
                      );
                    })
                  }
                </Select>
              }
            </div>
          </Modal>
          {
            this.state.openActionModal ?
              <Modal
                title="Confirmation Message"
                visible={this.state.openActionModal}
                onOk={this.handleCorrectAction} // Right now just for posting schedule
                onCancel={this.handleCloseActionModal}
                okText="OK"
                cancelText="CANCEL"
              >{this.state.actionModalText}</Modal> : null
          }


          { this.state.liveScheduleUpdate &&
            <LiveScheduleUpdate
              contextMenuSelection={this.state.contextMenuSelection}
              itemDetails={this.state.selectedItem}
              updateSelectedItem={this.updateSelectedItem}
              closeLiveScheduleUpdate={this.closeLiveScheduleUpdate}
              updateOptimisticLiveSchedule={this.updateOptimisticLiveSchedule}
            />
          }

        </DashboardLayout>
      )
    } else return <Spinner />
  }
}

LiveScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  liveSchedule: PropTypes.object,
  editMode: PropTypes.bool.isRequired,
  optimisticReRender: PropTypes.bool.isRequired,
  optimisticLiveSchedule: PropTypes.array,
  hamburgerMenu: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user,
    liveSchedule: state.liveSchedules,
    editMode: state.editMode.status,
    optimisticReRender: state.liveScheduleOptimisticReRender.status,
    optimisticLiveSchedule: state.liveScheduleOptimisticSchedule.newLiveSchedule,
    hamburgerMenu: state.navigation.hamburgerMenu,
    postedScheduleResult: state.createPostedSchedule,
    liveScheduleParameters: state.liveScheduleParameters
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchLiveSchedules: bindActionCreators(
        liveScheduleActions.fetchLiveSchedules,
        dispatch
      ),
      updateEditModeStatus: bindActionCreators(
        liveScheduleActions.updateEditModeStatus,
        dispatch
      ),
      updateOptimisticReRenderStatus: bindActionCreators(
        liveScheduleActions.updateOptimisticReRenderStatus,
        dispatch
      ),
      updateOptimisticSchedule: bindActionCreators(
        liveScheduleActions.updateOptimisticSchedule,
        dispatch
      ),
      createPostedSchedule: bindActionCreators(
        postedScheduleActions.createPostedSchedule,
        dispatch
      ),
      updateLiveScheduleParameters: bindActionCreators(
        liveScheduleActions.updateLiveScheduleParameters,
        dispatch
      )
    }
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveScheduleView));





// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/LiveScheduleView.js